import React from 'react';
import FormattedValue from './FormattedValue';

const BranchRow = ({ branch, isExpanded, onToggle, grouped }) => (
  <div
    className={`StockCurrentGroupedTable__grid ${grouped ? 'StockCurrentGroupedTable__grid--grouped' : ''} StockCurrentGroupedTable__branch-row ${!isExpanded ? 'StockCurrentGroupedTable__branch-row--collapsed' : ''}`}
    onClick={() => onToggle(branch.branchName)}
  >
    <div className="StockCurrentGroupedTable__col--arrow">
      <span className={`StockCurrentGroupedTable__collapse-arrow ${isExpanded ? 'StockCurrentGroupedTable__collapse-arrow--expanded' : ''}`}>&#9656;</span>
    </div>
    <div className="StockCurrentGroupedTable__col--name">{branch.branchName}</div>
    <div className="StockCurrentGroupedTable__col--right"><FormattedValue value={branch.totalPallets} /></div>
    <div className="StockCurrentGroupedTable__col--right"><FormattedValue value={branch.totalVolume} /></div>
    <div className="StockCurrentGroupedTable__col--right"><FormattedValue value={branch.totalValue} minFractionDigits={2} /></div>
    <div className="StockCurrentGroupedTable__col--right"><FormattedValue value={branch.totalWeight} /></div>
    <div className="StockCurrentGroupedTable__col--right"><FormattedValue value={branch.totalQuantity} /></div>
  </div>
);

export default BranchRow;
